// Upgrades every [data-pc-wa] link from its no-JS href (snippets/pc-wa-link.liquid, qty 1) to the exact
// pc-quote.js wording. Product links read their quantity from [data-pc-qty-for="<id>"] at click time, and
// title / SKU / URL from their data-* attributes, which follow the chosen variant (dispatch 'pc:wa-refresh').
import { generalText, productQuoteText, orderText, waUrl } from '@pc/quote';

function upgrade(a) {
  const kind = a.dataset.pcWa;
  if (kind === 'general') {
    a.href = waUrl(generalText(a.dataset.category || ''));
    return;
  }
  const item = () => {
    const qtyEl = a.dataset.qtyFor && document.querySelector(`[data-pc-qty-for="${a.dataset.qtyFor}"]`);
    return { title: a.dataset.title, sku: a.dataset.sku, url: a.dataset.url, qty: qtyEl ? qtyEl.value || qtyEl.textContent : 1 };
  };
  const build = () => waUrl(kind === 'order' ? orderText(item()) : productQuoteText(item()));
  a.href = build();
  // refresh just before navigation so the chosen quantity is in the message
  a.addEventListener('pointerdown', () => { a.href = build(); });
  a.addEventListener('keydown', (e) => { if (e.key === 'Enter') a.href = build(); });
  // pc-product.js changes data-title / data-sku / data-url when another variant is picked
  a.addEventListener('pc:wa-refresh', () => { a.href = build(); });
}

document.querySelectorAll('[data-pc-wa]').forEach(upgrade);
